import React, { Component } from 'react';
import CompleteTenantRegistration from './completeTenantRegistration';

export default class SetTenantAdminPassword extends Component {

    render() {
        return <CompleteTenantRegistration requireEula /> ;
    }
}